import React, { useState } from "react";
import {
  APLICATIVOS,
  USUARIOS_JIRA,
  USUARIOS_MICROSOFT365,
  USUARIOS_ODOO,
  USUARIOS_GHL,
} from "./licenciamientoDatos";

// Cada pestaña es data-driven: título, columnas ({ key, label }) y filas.
// `agruparPor` combina en una sola celda (rowSpan) las filas consecutivas con el mismo valor.
const TABS = [
  {
    id: "aplicativos",
    label: "Aplicativos",
    titulo: "Aplicativos",
    agruparPor: "area",
    filas: APLICATIVOS,
    columnas: [
      { key: "area", label: "Área" },
      { key: "app", label: "APP" },
      { key: "contratados", label: "Contratados" },
      { key: "enUso", label: "En Uso" },
      { key: "costoUsuarioUsd", label: "Costo Usuario USD" },
      { key: "costoMensualUsd", label: "Costo Mensual USD" },
      { key: "costoAnualUsd", label: "Costo Anual USD" },
      { key: "costoUsuarioMxn", label: "Costo Usuario MXN" },
      { key: "costoMensualMxn", label: "Costo Mensual MXN" },
      { key: "costoAnualMxn", label: "Costo Anual MXN" },
      { key: "cuentaAdmin", label: "Cuenta Admin" },
      { key: "empresaPaga", label: "Empresa Paga" },
      { key: "formaPago", label: "Forma Pago" },
      { key: "periodicidadPago", label: "Periodicidad" },
      { key: "mesPago", label: "Mes Pago" },
    ],
  },
  {
    id: "jira",
    label: "Jira",
    titulo: "Licencias Jira",
    filas: USUARIOS_JIRA,
    columnas: [
      { key: "usuario", label: "Usuario" },
      { key: "correo", label: "Correo" },
    ],
  },
  {
    id: "microsoft365",
    label: "Microsoft 365",
    titulo: "Licencias Microsoft 365",
    filas: USUARIOS_MICROSOFT365,
    columnas: [
      { key: "usuario", label: "Usuario" },
      { key: "empresanet", label: "Empresa Básico Netjer" },
      { key: "empresarex", label: "Empresa Básico Rexten" },
      { key: "empresaest", label: "Empresa Básico Estándar" },
    ],
  },
  {
    id: "odoo",
    label: "Odoo",
    titulo: "Licencias Odoo",
    filas: USUARIOS_ODOO,
    columnas: [
      { key: "empresa", label: "Empresa" },
      { key: "nombre", label: "Nombre" },
      { key: "inicioSesion", label: "Iniciar sesión" },
    ],
  },
  {
    id: "ghl",
    label: "GHL",
    titulo: "Licencias Go High Level",
    filas: USUARIOS_GHL,
    columnas: [
      { key: "nombre", label: "Nombre" },
      { key: "correo", label: "Correo Electrónico" },
      { key: "tipoUsuario", label: "Tipo de Usuario" },
      { key: "ubicacion", label: "Ubicación" },
    ],
  },
];

const TablaLicencias = ({ tab }) => {
  const { titulo, filas, columnas, agruparPor } = tab;

  const tamanoGrupo = (index) => {
    let fin = index;
    while (fin + 1 < filas.length && filas[fin + 1][agruparPor] === filas[index][agruparPor]) {
      fin += 1;
    }
    return fin - index + 1;
  };

  return (
    <>
      <div className="dashboard-header">
        <h2 className="page-title">{titulo}</h2>
      </div>

      <div className="fc-table-container">
        <table className="dashboard-table">
          <thead>
            <tr className="dashboard-table-header">
              {columnas.map((col) => (
                <th key={col.key}>{col.label}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {filas.map((fila, index) => {
              const inicioGrupo =
                agruparPor &&
                (index === 0 || filas[index - 1][agruparPor] !== fila[agruparPor]);

              return (
                <tr key={index}>
                  {columnas.map((col) => {
                    if (col.key !== agruparPor) {
                      return <td key={col.key}>{fila[col.key]}</td>;
                    }
                    return inicioGrupo ? (
                      <td key={col.key} rowSpan={tamanoGrupo(index)} className="fc-bold">
                        {fila[col.key]}
                      </td>
                    ) : null;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

const Licenciamiento = () => {
  const [tabActiva, setTabActiva] = useState(TABS[0].id);
  const tab = TABS.find((t) => t.id === tabActiva);

  return (
    <div className="page-card">
      <h1 className="page-title">Licenciamiento</h1>

      <div className="lic-tabs">
        {TABS.map((t) => (
          <button
            type="button"
            key={t.id}
            onClick={() => setTabActiva(t.id)}
            className={`lic-tab ${tabActiva === t.id ? "lic-tab-active" : ""}`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="lic-content">
        <TablaLicencias tab={tab} />
      </div>
    </div>
  );
};

export default Licenciamiento;